import React from 'react';
import { Box } from '@material-ui/core';

import Slot from '../Slot';

const Loading = ({ columns }) => {
  const columnsArr = Array.from({ length: columns }, (v, index) => index);
  return (
    <>
      {columnsArr.map(col => (
        <Box key={col} className="appointment-column-loading">
          <Slot loading />
        </Box>
      ))}
    </>
  );
};

export default Loading;
